import { gql } from '@apollo/client'

export const GET_SUSPICIOUS_ACTIVITIES = gql`
  query GetSuspiciousActivities($filter: SuspiciousActivityFilter) {
    suspiciousActivities(filter: $filter) {
      id
      userId
      ipAddress
      activityType
      severity
      description
      metadata
      resolved
      resolvedBy
      resolvedAt
      createdAt
      user {
        id
        email
      }
    }
  }
`

export const GET_BLOCKED_IPS = gql`
  query GetBlockedIps($isActive: Boolean) {
    blockedIps(isActive: $isActive) {
      id
      ipAddress
      reason
      blockedBy
      blockedAt
      expiresAt
      isActive
      admin {
        id
        email
      }
    }
  }
`

export const GET_USER_ACTIVITIES = gql`
  query GetUserActivities($filter: ActivityFilter) {
    userActivities(filter: $filter) {
      id
      userId
      ipAddress
      userAgent
      action
      endpoint
      method
      statusCode
      metadata
      createdAt
      user {
        id
        email
      }
    }
  }
`

export const GET_SECURITY_STATS = gql`
  query GetSecurityStats {
    securityStats {
      userActivities {
        total
        last24Hours
        last7Days
        last30Days
      }
      suspiciousActivities {
        total
        unresolved
      }
      blockedIPs {
        active
      }
    }
  }
`
